<template>
  <section class="teacher__area pt-60 pb-60">
    <div class="container">
      <div class="row">
        <div class="col-xxl-12 d-flex justify-content-start">
          <div class="section__title-wrapper text-center mb-30">
            <h2 class="section__title">
              {{ $t("actions.our") }}
              <span class="yellow-bg yellow-bg-big"
                >{{ $t("actions.team")
                }}<img src="../../assets/img/shape/yellow-bg.png" alt=""
              /></span>
            </h2>
          </div>
        </div>
      </div>
      <div class="col-12 d-none">
        <div class="course__menu d-flex justify-content-lg-end mb-30">
          <div class="masonary-menu filter-button-group">
            <nav>
              <div
                className="nav nav-tabs justify-content-center"
                id="portfolio-tab"
                role="tablist"
              >
                <button
                  className="nav-link active"
                  id="nav-all-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-all"
                  type="button"
                  role="tab"
                  aria-controls="nav-all"
                  aria-selected="true"
                  @click="teamShow = false"
                >
                  {{ $t("navbar.rahbar") }}
                </button>
                <button
                  className="nav-link"
                  id="nav-trending-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-trending"
                  type="button"
                  role="tab"
                  aria-controls="nav-trending"
                  aria-selected="false"
                  @click="teamShow = true"
                >
                  {{ $t("actions.employee") }}
                </button>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div class="row">
        <LeaderCard
          v-for="(vm, index) in sortedLeaders"
          :key="index"
          :leader="vm"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LeaderCard from "./LeaderCard.vue";

export default {
  name: "InstructorArea",
  components: {
    LeaderCard,
  },
  data() {
    return {
      teamShow: false,
    };
  },
  computed: {
    ...mapGetters("leader", ["leader"]),
    sortedLeaders() {
      if (!this.leader) return [];
      return [...this.leader].sort((a, b) => {
        return a.level - b.level;
      });
    },
  },
  created() {
    this.getLeader();
  },
  methods: {
    ...mapActions("leader", ["getLeader"]),
  },
};
</script>
